import { PAGE_ID as MAIN_PAGE_ID } from "../../pages";

function parseQueryParams(queryString = "") {
  if (queryString.indexOf("?") === 0) {
    queryString = queryString.substr(1);
  }
  return queryString.split("&").reduce((acc, item) => {
    const params = item.split("=");
    acc[params[0]] = params[1];
    return acc;
  }, {});
}

function isMainPage(pageName) {
  return pageName === MAIN_PAGE_ID;
}

/**
 * getStaticContent - function to retrieve static texts by given group
 * Function has inside sideeffect, it checks queryParams, and if it
 * sees ?city=Something, it will change section directory to related city folder
 * @param  {String} contentGroup - name of group (file)
 * @return {Object}
 */
export default function getStaticContent(contentGroup, pageName) {
  const { replaceRules, [contentGroup]: content } = require(`../../pages/${
    isMainPage(pageName) ? "" : `${pageName}/`
  }_content`);

  const queryParams =
    typeof document !== "undefined"
      ? parseQueryParams(document.location.search || "")
      : {};

  let results = content[process.env.CONTENT_LANGUAGE];
  if (replaceRules && typeof replaceRules[contentGroup] !== "undefined") {
    const replaceGroup = replaceRules[contentGroup];
    Object.keys(replaceGroup).forEach((field) => {
      const paramName = replaceGroup[field];

      if (typeof queryParams[paramName] !== "undefined") {
        results[field] = queryParams[paramName].replace(/[^a-zA-Z0-9]/g, " ");
      }
    });
  }

  return results;
}



// WEBPACK FOOTER //
// ../src/utils/getStaticContent.js